import { render } from "./FairRoulette.vue?vue&type=template&id=361ccfb5&scoped=true"
import script from "./FairRoulette.vue?vue&type=script&lang=js"
export * from "./FairRoulette.vue?vue&type=script&lang=js"

import "./FairRoulette.vue?vue&type=style&index=0&id=361ccfb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361ccfb5"]])

export default __exports__